import { FC } from 'react';
import { ConversationAlreadyAcceptedEvent } from '@vs-online-only-app/state';
import ConversationOutcomeCard, {
  ConversationOutcomeCardType,
} from './ConversationOutcomeCard';

type Props = {
  event: ConversationAlreadyAcceptedEvent;
  onClose: () => void;
};

export const NewConversationAlreadyAcceptedCard: FC<Props> = ({
  event,
  onClose,
}) => {
  const {
    data: { associateName, new: isNewShopper },
  } = event;

  return (
    <ConversationOutcomeCard
      type={
        isNewShopper
          ? ConversationOutcomeCardType.CONVERSATION_REQUEST_NEW_SHOPPER
          : ConversationOutcomeCardType.CONVERSATION_REQUEST_FAMILIAR_SHOPPER
      }
      title={`${associateName} claimed the chat.`}
      subtitle="Keep an eye out for the next chat."
      onClose={onClose}
    />
  );
};
